import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { LatexRenderer } from '../../../components';

import 'katex/dist/katex.css';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    latex: {
      insertLatex: (latex: string) => ReturnType;
      updateLatex: (latex: string) => ReturnType;
    };
  }
}

export const LatexNode = Node.create({
  name: 'latex',
  group: 'inline',
  inline: true,
  selectable: false,
  atom: true,
  addCommands() {
    return {
      insertLatex:
        (latex: string) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              'data-latex': latex,
            },
          });
        },
      updateLatex:
        (latex: string) =>
        ({ commands }) => {
          // FIXME: This is still unusable
          return commands.updateAttributes(this.name, {
            'data-latex': latex,
          });
        },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'span[data-latex]',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.attributes, HTMLAttributes)];
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-latex': {
        default: '',
        parseHTML: (element) => element.getAttribute('data-latex'),
        renderHTML: (attributes) => ({
          'data-latex': attributes['data-latex'],
        }),
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(
      (props) => {
        return <LatexRenderer equation={props.node.attrs['data-latex']} />;
      },
      { as: 'span' },
    );
  },
});
